export const KEY_RENDER_STARTED = 'RENDER_STARTED'
export const KEY_RENDER_ENDED = 'RENDER_ENDED'
export const KEY_VIDEOS_STARTED = 'VIDEOS_STARTED'
export const KEY_FIRST_VIDEOS_RECEIVED = 'FIRST_VIDEOS_RECEIVED'
export const KEY_FIRST_THUMBNAIL_RENDERED = 'FIRST_THUMBNAIL_RENDERED'
export const KEY_FIRST_AUTOPLAY_LOADSTART = 'FIRST_AUTOPLAY_LOADSTART'
export const KEY_FIRST_AUTOPLAY_CANPLAY = 'FIRST_AUTOPLAY_CANPLAY'
export const KEY_PLAYER_LOADSTART = 'PLAYER_LOADSTART'
export const KEY_PLAYER_LOADEDMETADATA = 'PLAYER_LOADEDMETADATA'
